export function getLineArray (editingText, numOfLines) {
  const lineArray = [];
  // Store the length of each line in an array
  for (let i = 0; i < numOfLines; i++) {
    const line = editingText.querySelectorAll('text')[i];
    const isLineWithEol = line.classList.contains('eol');
    const isBlankLine = line.classList.contains('blank');
    const orderedLine = line.querySelector('tspan.ordered');
    const bulletsLine = line.querySelector('tspan.bullets');

    let handleListLine = 0;
    if (orderedLine) handleListLine += orderedLine.textContent.length;
    if (bulletsLine) handleListLine += bulletsLine.textContent.length;

    // Number of slots for cursor depends on the line is `eol` or `blank`
    const textLength = isLineWithEol && !isBlankLine
      ? line.textContent.length
      : line.textContent.length - 1;

    // Not counting the bullet or ordered characters
    lineArray.push(textLength + 1 - handleListLine);
  }
  return lineArray;
}

export function getCursorLineIndex (lineArray, currentCursorPosition, textAnchor = 'start') {
  let cursorLineIndex, lineIndex;
  let total = 0;
  for (lineIndex = 0; lineIndex < lineArray.length; lineIndex++) {
    total += lineArray[lineIndex];
    if (total > currentCursorPosition) {
      cursorLineIndex = currentCursorPosition - (total - lineArray[lineIndex]);
      break;
    }
  }

  cursorLineIndex = handleRightAlignment(lineArray, lineIndex, cursorLineIndex, textAnchor);
  return [lineIndex, cursorLineIndex];
}

function handleRightAlignment (lineArray, lineIndex, cursorLineIndex, textAnchor) {
  // If the text is right aligned, the cursor index counts from the end
  if (textAnchor === 'end') {
    cursorLineIndex = (lineArray[lineIndex] - 1) - cursorLineIndex;
  }
  return cursorLineIndex;
}

export function getStylingPart (start, end, editingText) {
  const textArray = editingText.querySelectorAll('text');
  const lineArray = INKIVE.Helpers.getLineArray(editingText, textArray.length);
  const startOutput = INKIVE.Helpers.getCursorLineIndex(lineArray, start);
  const endOutput = INKIVE.Helpers.getCursorLineIndex(lineArray, end);

  let lastLineToStyle = 0;
  let startLineToStyle = 0;
  let endParagraphIndex = -1;

  for (let i = 0; i < textArray.length; i++) {
    if (textArray[i].classList.contains('eol') || i === textArray.length - 1) {
      endParagraphIndex += 1;
      if (i >= endOutput[0]) {
        lastLineToStyle = i;
        break;
      }
    }
  }

  const paragraphArray = [];
  let startParagraphIndex = 0;
  textArray.forEach((text, index) => {
    if (text.classList.contains('eol') || index === textArray.length - 1) {
      paragraphArray.push(index);
    }
  });

  for (let j = 0; j < paragraphArray.length; j++) {
    if (startOutput[0] <= paragraphArray[j]) {
      startParagraphIndex = j;
      break;
    }
  }

  startLineToStyle = startParagraphIndex === 0 ? 0 : paragraphArray[startParagraphIndex - 1] + 1;
  return { startLineToStyle, lastLineToStyle, startParagraphIndex, endParagraphIndex };
}

export const getVariantId = (fontWeight = 400, fontStyle = '', fontData) => {
  const mapFontWeight = {
    normal: 400,
    bold: 700
  };

  const mapFontStyle = {
    normal: '',
    italic: 'italic'
  };

  const variant = `${mapFontWeight[fontWeight] || fontWeight || 400}${mapFontStyle[fontStyle] || ''}`;

  function fontSource (variantData) {
    return variantData.weight && variantData.weight.toString() === fontWeight.toString() &&
      ((!fontStyle && !variantData.slope) || variantData.slope?.toString() === fontStyle.toString());
  }

  return fontData.support?.sources?.find(variantData => {
    return fontSource(variantData) || (variantData.variant || variantData) === variant;
  })?.id || null;
};
